import { useContext, useEffect, useState } from "react";
import Layout from "../../Component/layout/main-layout";
import { GetLawsTable } from "../../api/Queries/get";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loading from "../../Component/loader/loader";
import { Context } from "../../Store/context";
import layoutBgImg from "../../Images/layout/laws.png";

const LawsTable = () => {
  const location = useLocation().pathname.split("/")[2];
  const [laws, setLaws] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { i18n, t } = useTranslation();
  const { showError } = useContext(Context);

  useEffect(() => {
    const getLaws = async () => {
      setIsLoading(true);
      try {
        const res = await GetLawsTable(location);
        setLaws(res?.data || null);
        
      } catch (error) {
        showError(error?.message);
      } finally {
        setIsLoading(false);
      }
    };
    if (location) {
      getLaws();
    }
  }, [location, showError]);

  const getLawPdf = (law) => {
    if (!law) return "";
    const currentLang = i18n.language;
    if (currentLang === "ru") {
      return law.rus_pdf || law.tm_pdf || "";
    }
    if (currentLang === "en") {
      return law.eng_pdf || law.tm_pdf || "";
    }
    return law.tm_pdf || "";
  };
  
  const pdf = getLawPdf(laws);

  return (
    <div className="mb-20">
      <Layout
        title={t("laws_codes")}
        page={t("tm_laws")}
        layoutBgImg={layoutBgImg}
      />

      <main className="media">
        <div
          className="bg-white mt-8 border border-secondary 
                     p-8 w-full dark:border-dark-border 
                     dark:bg-dark-box dark:text-dark-text"
        >
          {isLoading ? (
            <Loading />
          ) : pdf ? (
            <div className="h-[1000px] max-h-max">
              <iframe
                src={`${pdf}#toolbar=0&navpanes=0&view=FitH`}
                className="w-full h-full"
                frameBorder="0"
                title="PDF Viewer"
              />
            </div>
          ) : (
            <p className="text-center">PDF tapylmady</p>
          )}
        </div>
      </main>
    </div>
  );
};

export default LawsTable;